module.exports = __webpack_public_path__ + "img/03.27788c38.jpg";